var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClearSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 14.6668C4.31814 14.6668 1.33337 11.682 1.33337 8.00016C1.33337 4.31826 4.31814 1.3335 8.00004 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016C14.6667 11.682 11.6819 14.6668 8.00004 14.6668ZM8.00004 7.05736L6.11442 5.17174L5.17161 6.11454L7.05724 8.00016L5.17161 9.88576L6.11442 10.8286L8.00004 8.94296L9.88564 10.8286L10.8284 9.88576L8.94284 8.00016L10.8284 6.11454L9.88564 5.17174L8.00004 7.05736Z",
    fill: "#424242"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClearSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clear_search.c7864e27.svg";
export { ForwardRef as ReactComponent };